import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Generate a unique key for cart items based on profile + grind
const generateItemKey = (productId, profile, grind) => `${productId}__${profile}__${grind}`;

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (product, { profile, grind, quantity = 1 }) => {
        const items = get().items;
        const key = generateItemKey(product.id, profile, grind);
        const existingItem = items.find(item => item.key === key);
        
        if (existingItem) {
          set({
            items: items.map(item =>
              item.key === key
                ? { ...item, quantity: item.quantity + quantity }
                : item
            )
          });
        } else {
          set({
            items: [
              ...items,
              {
                key,
                id: product.id,
                name: product.name,
                price: product.price,
                image_url: product.image_url,
                lookup_key: product.lookup_key,
                weight: product.weight,
                profile,
                grind,
                quantity
              }
            ]
          });
        }
      },
      
      removeItem: (key) => {
        set({ items: get().items.filter(item => item.key !== key) });
      },
      
      updateQuantity: (key, quantity) => {
        if (quantity <= 0) {
          get().removeItem(key);
          return;
        }
        set({
          items: get().items.map(item =>
            item.key === key ? { ...item, quantity } : item
          )
        });
      },
      
      getSubtotal: () => {
        return get().items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      },
      
      getTotalBags: () => {
        return get().items.reduce((sum, item) => sum + item.quantity, 0);
      },
      
      getItemCount: () => {
        return get().items.reduce((sum, item) => sum + item.quantity, 0);
      },
      
      clearCart: () => set({ items: [] })
    }),
    {
      name: 'legatum-cart-storage',
    }
  )
);

// Helper function to format Colombian pesos
export const formatCOP = (amount) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};
